var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"view-user-details"}},[_c('b-row',[_c('b-col',{attrs:{"offset":"2"}},[_c('ProgressList',{attrs:{"index":1}})],1)],1),_c('b-row',[_c('b-col',[_c('UserDetailsForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }